import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {FormattedMessage} from 'react-intl'
import {url} from '../../services/utils'
import categories from '../../data/shopWidgetCategories'
import {useRouter} from 'next/router'
import dynamic from 'next/dynamic'
import {IGlobalProduct, IState} from "../../types/state";
import VirtualProduct from "../shared/products/VirtualProduct";
import cls from "./shop.module.scss"

const WidgetCategories = dynamic(() => import('../widgets/WidgetCategories'))
const BlockProductsCarousel = dynamic(() => import('../blocks/BlockProductsCarousel'))
const PageHeader = dynamic(() => import('../shared/PageHeader'))
const SimpleProduct = dynamic(() => import('../shared/products/SimpleProduct'))
const ConfigProduct = dynamic(() => import('../shared/products/ConfigProduct'))
// @ts-ignore
const BundleProduct = dynamic(() => import('../shared/products/BundleProduct'))


interface IShopPageProduct {
    bundle: Array<any>,
    changes: boolean,
    configurableVariantes: Array<any>,
    currencies: any,
    dbName: string,
    layout: string,
    loading: boolean,
    locale: string,
    productData: any,
    productSlug: string | any,
    rate: number,
    domain: string,
    relProduct: any,
    sidebarPosition: string,
    getBuilderData: any
    translations: {[key: string]: string}
}

const ShopPageProduct: React.FC<IShopPageProduct> = (props: IShopPageProduct) => {

    const {
        productSlug,
        layout = 'standard',
        productData,
        changes,
        sidebarPosition = 'start',
        loading,
        bundle,
        dbName,
        relProduct,
        rate,
        configurableVariantes,
        currencies,
        locale,
        getBuilderData,
        translations
    } = props
    const [isLoading, setIsLoading] = useState<boolean>(loading)

    const router = useRouter()
    const [product, setProduct] = useState<IGlobalProduct>(productData);
    const [change, setChange] = useState<boolean>(changes);
    const [relatedProducts, setRelatedProducts] = useState<IGlobalProduct[]>(relProduct);

    const customer = useSelector((state: IState) => state?.customer)
    const currency = useSelector((state: IState) => state?.rate?.current.code)

    const selectedData = locale
    const prevProductSlugRef = useRef()
    const prevLocaleRef = useRef()
    const [filtered, setFiltered] = useState({})

    useEffect(() => {
        prevProductSlugRef.current = productSlug
        // prevLocaleRef.current = locale
        setRelatedProducts(relProduct)
        setProduct(productData);
        setChange(!change)

    }, [changes])

    function renderSwitch(product: IGlobalProduct) {
        switch (product.type) {
            case 'simple':
                return <SimpleProduct
                    productData={product}
                    layout={layout}
                    productSlug={productSlug}
                    dbName={dbName}
                    rate={props.rate}
                    locale={locale}
                    change={change}
                    getBuilderData={getBuilderData}
                    translations={translations}
                />;
            case 'configurable':
                return <ConfigProduct
                    productData={productData}
                    layout={layout}
                    productSlug={productSlug}
                    locale={locale}
                    configurableVariantes={configurableVariantes || null}
                    dbName={dbName}
                    rate={rate}
                    filtered={filtered}
                    setFiltered={setFiltered}
                    change={change}
                    getBuilderData={getBuilderData}
                    translations={translations}
                />;
            case 'bundle':
                return <BundleProduct
                    // @ts-ignore
                    productData={product}
                    layout={layout}
                    productSlug={productSlug}
                    locale={locale}
                    bundle={bundle}
                    dbName={dbName}
                    rate={props.rate}
                    relatedProducts={relatedProducts}
                    change={change}
                    // props
                    getBuilderData={getBuilderData}
                    translations={translations}
                />;
            case 'virtual':
                return <VirtualProduct
                    product={product}
                    layout={layout}
                    productSlug={productSlug}
                    dbName={dbName}
                    rate={props.rate}
                    locale={locale}
                    change={change}
                    getBuilderData={getBuilderData}
                    translations={translations}
                />;
            default:
                return 'foo';
        }
    }

    const breadcrumb = [
        {
            title: <FormattedMessage id="home" defaultMessage="Home"/>,
            url: `https://${dbName}/`,
        },
        {title: product.product_flat?.[0]?.name, url: `https://${dbName}${url.product(product)}`},
    ]

    const related = (
        <FormattedMessage id="related_products" defaultMessage="Related products"/>
    )

    let content

    if (layout === 'sidebar') {
        const sidebar = (
            <div className={cls["shop-layout__sidebar"]}>
                <div className={cls.block}>
                    <div className={cls["block-sidebar__item"]}>
                        <WidgetCategories categories={categories} location="shop"/>
                    </div>
                    <div className={`${cls["block-sidebar__item"]} ${cls["d-none"]}`}>
                    </div>
                </div>
            </div>
        )
        content = (
            <div className="container">
                <div className={`${cls["shop-layout"]} ${cls[`shop-layout--sidebar--${sidebarPosition}`]}`}>
                    {sidebarPosition === 'start' && sidebar}
                    <div className={cls["shop-layout__content"]}>
                        <div className={cls.block}>
                            {
                                renderSwitch(product)
                            }
                        </div>
                        {Object.keys(relatedProducts).length > 0 && (
                            <BlockProductsCarousel
                                title={related}
                                layout="grid-4-sm"
                                products={Object.values(relatedProducts)}
                                locale={router.locale}
                                change={change}
                                dbName={dbName}
                            />
                        )}
                    </div>
                    {sidebarPosition === 'end' && sidebar}
                </div>
            </div>
        )
    } else {
        content = (
            <React.Fragment>
                <div className={cls.block}>
                    <div className="container">
                        {
                            renderSwitch(product)
                        }
                    </div>
                </div>
                {Object.keys(relatedProducts).length > 0 && (
                    <BlockProductsCarousel
                        customer={customer}
                        title={related}
                        layout="grid-5"
                        products={Object.values(relatedProducts)}
                        locale={router.locale}
                        change={change}
                        dbName={dbName}
                    />
                )}
            </React.Fragment>
        )
    }
    return (
        <React.Fragment>
            <PageHeader breadcrumb={breadcrumb}/>

            <div>
                {content}
            </div>
        </React.Fragment>
    )
}


export default ShopPageProduct
